import { useCallback, useContext } from 'react';
import { useRouter } from 'next/navigation';
import { mutate } from 'swr';
import { UserActionsContext, UserContext } from './user-context';
import { fetcherWithToken } from '@/shared/api/fetcher';
import { setGtmUserId } from '@/shared/libs/analytics/gtm';
import Cookies from 'js-cookie';

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};
export const useUserActions = () => {
  const actions = useContext(UserActionsContext);
  if (!actions) {
    throw new Error('useUserActions must be used within UserProvider');
  }
  return actions;
};

export function useLogout() {
  const { setUser } = useUser();
  const router = useRouter();

  const killSession = useCallback(() => {
    Cookies.remove('sessionId');
    sessionStorage.removeItem('termsConfirmed');
    sessionStorage.removeItem('playResponsiblyConfirmed');
    setGtmUserId(undefined);
    setUser({
      isAuth: false,
      authStatus: 'anonymous',
      isUserLoading: false,
    });
    mutate(() => true, undefined, { revalidate: false });
  }, [setUser]);

  const logout = useCallback(() => {
    return fetcherWithToken('/logout').finally(() => {
      killSession();
      router.push('/');
    });
  }, [killSession, router]);

  return { logout, killSession };
}

export * from './store';
